import JsonLd from "@/components/base/JsonLd";
import PageHeader from "@/components/feature/PageHeader";
import FaqAccordion from "@/components/feature/FaqAccordion";
import useSeo from "@/hooks/useSeo";
import { faqs } from "@/mocks/faqs";

const ORIGIN = "https://jyhtdd.cn";

export default function FaqPage() {
  useSeo({
    title: "常见问题 - 看料爆料｜投稿方式、隐私安全与核实规则",
    description:
      "看料爆料常见问题解答，涵盖投稿入口在哪里、私信与表单投稿的区别、平台是否会公开投稿人身份、线索多久处理、什么样的线索会被退回等核心疑问。",
    keywords: "看料爆料常见问题,看料爆料投稿方式,爆料投稿隐私,匿名投稿安全,爆料核实规则",
    canonical: `${ORIGIN}/faq`,
  });

  const groups = Array.from(new Set(faqs.map((f) => f.group)));

  const jsonLd = [
    {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((item) => ({
        "@type": "Question",
        name: item.q,
        acceptedAnswer: { "@type": "Answer", text: item.a },
      })),
    },
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "首页", item: `${ORIGIN}/` },
        { "@type": "ListItem", position: 2, name: "常见问题", item: `${ORIGIN}/faq` },
      ],
    },
  ];

  return (
    <>
      <JsonLd data={jsonLd} />
      <PageHeader
        crumbs={[{ label: "首页", to: "/" }, { label: "常见问题" }]}
        eyebrow="常见问题"
        title="关于投稿、隐私与核实，你问得最多的都在这里"
        desc="我们尽量把流程讲清楚，而不是只给一句「请放心」。如果你的疑问不在下面，可以发送邮件，我们会补充到这一页。"
      />

      <section className="mx-auto w-full max-w-shell px-4 py-10 md:px-6 md:py-14">
        <div className="space-y-12">
          {groups.map((group) => (
            <div key={group}>
              <h2 className="flex items-center gap-2.5 font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                <span className="h-5 w-1 rounded-full bg-primary-500" aria-hidden="true"></span>
                {group}
              </h2>
              <div className="mt-5">
                <FaqAccordion items={faqs.filter((f) => f.group === group)} />
              </div>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}